import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationKeys } from './useNotifications';
import { notificationRepository } from '../../infrastructure/repositories';
import type { ArchiveNotificationsRequest } from '../../domain/types';

export function useArchiveNotifications() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ArchiveNotificationsRequest) => notificationRepository.archive(request),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationKeys.all }),
  });
}
